module.exports = __webpack_public_path__ + "static/media/firstIcon.06ba792a.svg";